export const FAVORITE_MEDIA_FETCH_REQUEST = 'FAVORITE_MEDIA_FETCH_REQUEST';
export const FAVORITE_MEDIA_FETCH_SUCCESS = 'FAVORITE_MEDIA_FETCH_SUCCESS';
export const FAVORITE_MEDIA_FETCH_FAILURE = 'FAVORITE_MEDIA_FETCH_FAILURE';
export const ON_FAVORITES_FILTER_CHANGE = 'ON_FAVORITES_FILTER_CHANGE';